import React, { useMemo, useState } from 'react';
import ApiReference from '../components/ApiReference';
import { useParams, useNavigate } from 'react-router-dom';

export default function Docs() {
  const params = useParams();
  const navigate = useNavigate();
  const docId = params.docId || 'chat-completions';
  const [query, setQuery] = useState('');

  const endpoints = useMemo(() => [
    { id: 'chat-completions', title: 'Chat Completions', path: '/docs/chat-completions' },
  ], []);

  const filtered = endpoints.filter(e => e.title.toLowerCase().includes(query.toLowerCase()));

  return (
    <div className="h-full w-full overflow-hidden">
      <ApiReference endpointId={docId} />
    </div>
  );
}
